export default "__VITE_ASSET__8497bd82__"